'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React$1 = require('react');
require('prop-types');
var AddressData = require('./AddressData.js');
var StateSelectField = require('./StateSelectField.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var TextField = require('../../node_modules/@material-ui/core/esm/TextField/TextField.js');

var CityTextField =
/*#__PURE__*/
function (_PureComponent) {
  inherits(CityTextField, _PureComponent);

  function CityTextField() {
    classCallCheck(this, CityTextField);

    return possibleConstructorReturn(this, getPrototypeOf(CityTextField).apply(this, arguments));
  }

  createClass(CityTextField, [{
    key: "cityLabel",
    value: function cityLabel() {
      return StateSelectField.billingAddressCountry(this.props.currentState) == AddressData.OPTION_CANADA ? 'Municipality' : 'City';
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(TextField["default"], {
        error: ObjectHelper.isPresent(this.props.errorText),
        helperText: this.props.errorText,
        name: "city",
        label: this.cityLabel(),
        value: this.props.currentValue,
        onChange: this.props.onChange,
        fullWidth: true
      });
    }
  }]);

  return CityTextField;
}(React$1.PureComponent);

module.exports = CityTextField;
